import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IBrandsState = { };

const designTypeReducer = (
  state: types.IBrandsState = defaultState, 
  action: IAction | types.ISetBrandAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_BRAND: {
      return {...state, brands: (action as types.ISetBrandsAction).brands};
    }
    case actionTypes.SET_BRAND_INFO: {
      return {...state, brand: (action as types.ISetBrandAction).brand};
    }
    case actionTypes.ADD_SUCCESS_BRAND: {
      return {...state, brandResponse: (action as types.IServerSuccessAction).brandResponse};
    }
    case actionTypes.ADD_SUCCESS_CUSTOM_META_DATA_VEHICLE: {
      return {...state, customMetaDataVehicleResponse: (action as types.IServerSuccessCustomMetaDataVehicleAction).customMetaDataVehicleResponse};
    }
    case actionTypes.SET_SEARCH_BRAND: {
      return {...state, brandSearches: (action as types.ISetSearchAction).brandSearches};
    }
    case actionTypes.SET_BRAND_COUNTERS: {
      return {...state, counter: (action as types.ISetBrandCountersAction).counter};
    }
    case actionTypes.SET_COUNTER_BRANDS: {
      return {...state, counterDesigns: (action as types.ISetCounterAction).counterBrands};
    }
    case actionTypes.ADD_SUCCESS_FAVORITE: {
      return {...state, brandFavoriteResponse: (action as types.IBrandFavoriteSuccessAction).brandFavoriteResponse};
    }
    case actionTypes.SET_BRAND_NAME: {
      return {...state, brandNameResponse: (action as types.ISetBrandName).brandNameResponse};
    }
    case actionTypes.SET_ADD_UPDATE_BRAND: {
      return {...state, addUpdateResponse: (action as types.ISetAddUpdateBrand).addUpdateResponse};
    }
    case actionTypes.SET_ADD_UPDATE_BRAND_SNACKBAR: {
      return {...state, addUpdateResponseSnackbar: (action as types.ISetAddUpdateBrandSnackBar).snackbar};
    }
    case actionTypes.SET_MOVE_FILE_RESPONSE: {
      return {...state, moveFileResponse: (action as types.ISetMoveFileResponse).moveFileResponse};
    }
    case actionTypes.DELETE_BRAND_REQUEST:{
      return {...state, deletedBrand:false};
    }
    case actionTypes.DELETE_BRAND_SUCCESS: {
      return {...state, deletedBrand:true};
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
